import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function deleteUserAPI(userId) {
  const url = `${AWS_API_URL}/admin/users/${userId}`;

  return deleteRequest(url, await authorize());
}
